import "./index.css";
import { app } from "./workspace-app";

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");
app.mount(container);
